import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const WelcomeSection = ({ id }) => {
  const [QWSList, setQWSList] = useState([]);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `WelcomeSection/GetAboutSectionList?displayesInID=${id}`
      );
      if (response && response.length > 0) {
        setQWSList(response);
      } else {
        setQWSList([]);
      }
    } catch (error) {
      setQWSList([]);
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  if (!QWSList || QWSList.length == 0) {
    return null;
  }

  return (
    <>
      <section className="wpo-story-section section-padding" id="story">
        <div className="container-fluid">
          {QWSList.map((section, index) => (
            <div className="wpo-story-wrap" key={index}>
              <div className="wpo-story-item">
                <div className="wpo-story-img-wrap">
                  <div
                    className="wpo-story-img wow zoomIn"
                    data-wow-duration="1000ms"
                    // style={{
                    //   width: "360px",
                    //   height: "360px",
                    //   borderRadius: "50%", // Makes the container a perfect circle
                    //   overflow: "hidden",  // Ensures the image stays within the circle
                    //   position: "relative",
                    // }}
                  >
                    <img
                      src={`${ImageURL}${section.imagePath}`}
                      alt={`Section ${index}`}
                      style={{
                        width: "100%", // Ensures the image covers the entire circle
                        height: "100%", // Maintains the aspect ratio
                        objectFit: "cover", // Ensures the image fills the circle without distortion
                      }}
                    />
                    {/* <img
                      src={
                        "https://ph4qacoreapi.meridianconvention.com/Images/Banners/Thumb/13_ce5bf91b-7bc4-4e4d-bdc3-d4a0dc567d87..jpg"
                      }
                      alt={`Section ${index}`}
                    /> */}
                  </div>
                  <div className="wpo-img-shape">
                    <img src="/assets/images/Wedding/shape.png" alt="Shape" />
                  </div>
                </div>
                <div className="wpo-story-content">
                  <div
                    className="wpo-story-content-inner wow fadeInRightSlow"
                    data-wow-duration="1700ms"
                  >
                    <h2>{section.title}</h2>
                    <p>{section.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default WelcomeSection;
